import { formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeDefaultColumnStmtInstruction = `
#### Remove default column value

This statement removes the default value from the column in the database table.

- Syntax: \`remove default column <entity_name>.<column_name>;\`
- Example: \`remove default column Article.createdAt;\`
`;
export const stmtRemoveDefaultColumn = ({ entityName, columnName }) => {
    return `remove default column ${entityName}.${columnName};`;
};
export const stmtForHumanRemoveDefaultColumn = ({ entityName, columnName }) => {
    return `Remove the default value from the column __${columnName}__ in the database table __${entityName}__.`;
};
export const removeDefaultColumnHandler = createSchemaStatementHandler({
    type: 'remove default column',
    parse: line => {
        const match = /^remove default column (?<entityName>\w+)\.(?<columnName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove default column',
                entityName: formatEntityName(match.groups.entityName),
                columnName: formatFieldName(match.groups.columnName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRemoveDefaultColumn,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.updateColumnDefault(stmt.entityName, stmt.columnName, undefined));
    },
});
//# sourceMappingURL=RemoveDefaultColumnStmt.js.map